<template>
  <aside
    class="sidebar notifications-sidebar"
    id="notificationsSidebar"
    :class="{ 'hide-sidebar': hideSidebar }"
  >
    <div class="text">Notifications:{{ notificationsCount }}</div>
    <div class="notification-items">
      <div
        class="item"
        v-bind:key="index"
        v-for="(item, index) in items"
        v-on:click="markAsRead(item)"
      >
        <span class="notification-item-title" v-text="item.data.title"></span>
        <span class="notification-item-body" v-text="item.data.body"></span>
      </div>
    </div>
  </aside>
</template>

<script>
export default {
  props: {
    hideSidebar: {
      type: Boolean,
      default: false
    }
  },

  updated() {
    new window.Ps(this.$el);
  },

  computed: {
    items() {
      return this.$store.getters['Notifications/all'];
    },

    notificationsCount() {
      return this.$store.getters['Notifications/count'];
    }
  },

  methods: {
    markAsRead(item) {
      window.Ajax.post(`/notifications/${item.id}/mark-as-read`)
        .then(response => {
          window.Ajax.get('/notifications')
            .then(response => {
              this.$store.commit('Notifications/set', response.data);
            })
            .catch(error => {});
        })
        .catch(error => {
          window.toastify.error(
            'Error',
            'Sorry, there was an error marking the notification as read.'
          );
        });
    }
  }
};
</script>
